import React from "react";
import LogHistoryListItem from "../../components/logHistory/LogHistoryList/LogHistoryListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const LogHistoryListPage = ()  => {

    useTitle(t`List Log History`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <LogHistoryListItem showAdd={true} {...query} />
        </Box>
    )
}

export default LogHistoryListPage;
